import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { connect as connectR } from 'react-redux';
import TurnoverItem from './turnover-item';
import translate from '../../translate';
import { LoadTurnoverYears } from '../../../store/turnoverSlice';
import { REQUEST_PENDING } from '../../../store/network/managedRequest';
import { PbRequest } from '../../../store/pbRequest';

class TurnoverCard extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        LoadTurnoverYears: PropTypes.func.isRequired,
        loadYears: PropTypes.shape({
            status: PropTypes.string.isRequired,
        }).isRequired,
        loadYearsData: PropTypes.array.isRequired,
    };

    componentDidMount() {
        this.props.LoadTurnoverYears();
    }

    _getItems = () => {
        const years = this.props.loadYearsData;
        if (this.props.loadYears.status === REQUEST_PENDING) {
            return (
                <div className="year-wrapper">
                    <div className="info-message">
                        {this.props.strings.loading}
                    </div>
                </div>
            );
        }
        if (!years || years.length === 0) {
            return (
                <div className="year-wrapper">
                    <div className="info-message">
                        {this.props.strings.noTurnover}
                    </div>
                </div>
            );
        }

        return _.map(years, (year) => {
            return <TurnoverItem key={year} year={year} />;
        });
    };

    render() {
        const turnoverItems = this._getItems();
        return (
            <div className="card level-1">
                <div className="card-content">
                    <div className="card-desc">
                        <h3 className="headline1">
                            {' '}
                            {this.props.strings.title}{' '}
                        </h3>
                    </div>
                    {turnoverItems}
                </div>
            </div>
        );
    }
}

export default connectR(
    (state) => ({
        loadYears: state.pbRequest[PbRequest.TURNOVER_LOAD_YEARS],
        loadYearsData: state.turnover.availableYears,
    }),
    {
        LoadTurnoverYears,
    }
)(translate('TurnoverCard')(TurnoverCard));
